import axios from "axios";

export const SERVER_URL = "https://odineducation-api.cubettech.in/";
export const BOT_URL = "https://obot.odineducation.co.za/dashboard";
export const PORTAL_API_URL = "https://odineducation-api.cubettech.in/api/";
export const NEW_API_URL = "https://obot-api.odineducation.co.za/";

export const GG_API = "AIzaSyClrULWWMKAxzpwxxdUSyjwpXZKVz9LI40";
export const ReCAPTCHA_API = "6Lc4dGAiAAAAAO2JwPls9u07-UQfArsJbgX5rimv";
export const kitsoLogo = "https://odin-bot-storage.s3.us-east-1.amazonaws.com"

// export default axios.create({
//   baseURL: PORTAL_API_URL,
//   headers: {
//     Accept: "application/json",
//   },
// });

export const newApi = axios.create({
  baseURL: NEW_API_URL,
  headers: {
    Accept: "application/json",
  },
});

// Add response interceptor to save sessionid to localStorage
newApi.interceptors.response.use(
  (response) => {
    // Check if sessionid exists in response data
    const sessionid = response?.data?.data?.session_id;
    if (sessionid) {
      localStorage.setItem('sessionid', sessionid);
    }
    return response;
  },
  (error) => {
    // Handle errors and still check for sessionid in error response
    const sessionid = error?.response?.data?.session_id;
    if (sessionid) {
      localStorage.setItem('sessionid', sessionid);
    }
    return Promise.reject(error);
  }
);

const defaultApi = axios.create({
  baseURL: PORTAL_API_URL,
  headers: {
    Accept: "application/json",
  },
});
export default defaultApi;
